var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from "redux-saga/effects";
import { GET_WHATSAPP_SUMMARY_REQUEST, getWhatsappSummaryFailure, getWhatsappSummarySuccess } from "../../actions";
import APIIN from "../../../utils/APIIN";
const onGetWhatsappSummary = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        const countryCode = "IN";
        try {
            APIIN.get(`/report/notification/wa/summary?countryCode=${countryCode}`)
                .then((data) => {
                resolve(data);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* getWhatsappSummaryWorker(action) {
    try {
        const data = yield call(onGetWhatsappSummary, action);
        yield put(getWhatsappSummarySuccess(data));
    }
    catch (error) {
        yield put(getWhatsappSummaryFailure(error));
    }
}
export function* watchGetWhatsappSummaryData() {
    yield takeLatest(GET_WHATSAPP_SUMMARY_REQUEST, getWhatsappSummaryWorker);
}
